<div class="dropdown-container">
  @if (label) {
    <label [for]="label">{{ label }}</label>
  }
  <p-dropdown
    #pDropdown
    [id]="label"
    [options]="options"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    (onChange)="onChange($event.value)"
    (onBlur)="onTouched()"
    [filter]="filter"
    (onFilter)="filterChange.emit($event)"
    (onShow)="onDropdownShow()"
    [virtualScroll]="true"
    [virtualScrollItemSize]="32"
    [ngClass]="getValidationNgClasses(control)">
  </p-dropdown>
  @if (description) {
    <small class="dropdown-description">{{ description }}</small>
  }
  @if (control?.invalid && (control?.dirty || control?.touched)) {
    <div class="error-messages">
      @for (message of errorMessages; track $index) {
        <small class="dropdown-error-message">{{ message }}</small>
      }
    </div>
  }
</div>
